<h2 class="mat-h2" matDialogTitle>Active Affiliates</h2>

<mat-dialog-content style="padding-top:0;">
  <mat-divider></mat-divider>
  <p class="mat-body-2">These affiliates had at least one impression or click associated to this ad campaign in the past 30 days.</p>
  <table mat-table [dataSource]="($dataSource | async)" class="mat-elevation-z1">

    <ng-container matColumnDef="affiliateCompanyName">
      <th mat-header-cell *matHeaderCellDef>Affiliate Company Name</th>
      <td mat-cell *matCellDef="let affiliate"> {{affiliate.affiliate_name}} </td>
    </ng-container>

    <ng-container matColumnDef="affiliateDefaultWebsite">
      <th mat-header-cell *matHeaderCellDef>Affiliate Default Website</th>
      <td mat-cell *matCellDef="let affiliate">
        {{affiliate.affiliate_website_url | stripUrl}}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>

    <tr class="mat-mdc-row" *matNoDataRow>
      <td class="mat-mdc-cell" [attr.colspan]="2">There are no active affiliates for this ad.</td>
    </tr>
  </table>
  <div class="button-group">
    <button mat-raised-button mat-dialog-close color="primary">Close</button>
  </div>
</mat-dialog-content>
